var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.506 21.9396L2.4 7.2H21.6L19.494 21.9396C19.4123 22.5115 19.127 23.0347 18.6905 23.4132C18.254 23.7917 17.6957 24 17.118 24H6.882C6.30429 24 5.74595 23.7917 5.3095 23.4132C4.87304 23.0347 4.58775 22.5115 4.506 21.9396ZM22.8 2.4H16.8V1.2C16.8 0.88174 16.6736 0.576515 16.4485 0.351472C16.2235 0.126428 15.9183 0 15.6 0H8.4C8.08174 0 7.77652 0.126428 7.55147 0.351472C7.32643 0.576515 7.2 0.88174 7.2 1.2V2.4H1.2C0.88174 2.4 0.576515 2.52643 0.351472 2.75147C0.126428 2.97652 0 3.28174 0 3.6C0 3.91826 0.126428 4.22348 0.351472 4.44853C0.576515 4.67357 0.88174 4.8 1.2 4.8H22.8C23.1183 4.8 23.4235 4.67357 23.6485 4.44853C23.8736 4.22348 24 3.91826 24 3.6C24 3.28174 23.8736 2.97652 23.6485 2.75147C23.4235 2.52643 23.1183 2.4 22.8 2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationDeleteIcon);
export default __webpack_public_path__ + "static/media/reservation-delete-icon.ff5848728a2a1b7f6075734ce88937f5.svg";
export { ForwardRef as ReactComponent };